import { render } from "./BulkUploadModal.vue?vue&type=template&id=c32194de"
import script from "./BulkUploadModal.vue?vue&type=script&lang=js"
export * from "./BulkUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__